import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { throttle } from '../../utils/performance';
import { scrollToTop } from '../../utils/scrollTo';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = throttle(() => {
      setVisible(window.scrollY > 500);
    }, 100);

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.9 }}
          whileHover={{ scale: 1.08, borderColor: 'rgba(201, 168, 76, 0.4)' }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-20 md:bottom-8 right-4 sm:right-5 z-40 w-11 h-11 flex items-center justify-center rounded-full border border-white/10 bg-ant-bg-2/90 backdrop-blur-sm text-ant-gold shadow-lg focus:outline-none focus:ring-2 focus:ring-ant-gold"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
          </svg>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;